import { render, staticRenderFns } from "./JumpScrollButton.vue?vue&type=template&id=1c743382&scoped=true"
import script from "./JumpScrollButton.vue?vue&type=script&setup=true&lang=js"
export * from "./JumpScrollButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JumpScrollButton.vue?vue&type=style&index=0&id=1c743382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c743382",
  null
  
)

export default component.exports